<template>
    <form
        class="form basic-form import-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <h3 class="field-title">Import trips or bucket lists</h3>
        <div class="form-field">
            <div class="label required">Type of data:</div>
            <EnumRadio v-model="form.type.value" group="import_job_type" />
            <FormError :errors="errors.type" />
            <div v-if="form.type.value !== null">
                <a :href="`/export/example/${form.type.value}`">
                    Download example
                </a>
            </div>
        </div>
        <div class="form-field">
            <label for="file" class="required">TSV file:</label>
            <input
                id="file"
                name="file"
                type="file"
                @change="handleFileChange($event)"
            />
            <FormError :errors="errors.file" />
        </div>
        <div v-if="successMessage" class="form-message">
            {{ successMessage }}
        </div>
        <div class="actions">
            <Bttn id="submit-import" type="submit">Import</Bttn>
        </div>
    </form>
</template>
<script>
import BaseForm from "js/components/base/BaseForm";
import EnumRadio from "js/components/forms/EnumRadio";
import FormError from "js/components/forms/FormError";

export default {
    name: "ImportForm",
    components: { EnumRadio, FormError },
    extends: BaseForm,
    data() {
        return {
            form: {
                type: {
                    value: null,
                },
                file: {
                    value: null,
                },
            },
        };
    },
    methods: {
        handleFileChange(e) {
            if (e.target.files.length && e.target.files[0]) {
                this.form.file.value = e.target.files[0];
            }
        },
    },
};
</script>
